import { render, staticRenderFns } from "./Sophrologie.vue?vue&type=template&id=659cc055&"
import script from "./Sophrologie.vue?vue&type=script&lang=js&"
export * from "./Sophrologie.vue?vue&type=script&lang=js&"
import style0 from "./Sophrologie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports